<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import debounce from 'lodash-es/throttle';
import router from '../router';
import TwOverlay from '../components/TwOverlay';

export default {
  name: 'Schedules',
  data() {
    return {
      channelName: '',
    };
  },
  components: {
    TwOverlay,
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      getSchedules: 'schedules/getSchedules',
      setScheduleSearch: 'schedules/setScheduleSearch',
      setEditSchedule: 'schedules/setEditSchedule',
    }),
    returnRegularSchedules(schedules) {
      const numberSchedules = [];
      schedules.sort();
      schedules.forEach((schedule) => {
        if (!/[a-z]/i.test(schedule)) {
          numberSchedules.push(schedule);
        }
      });
      return numberSchedules.join(', ');
    },
    returnSpecialSchedules(schedule) {
      let specialSchedule = '';
      if (/[a-z]/i.test(schedule)) {
        specialSchedule = schedule;
      }
      return specialSchedule;
    },
    getRightWebService(xmlChannel, channelName) {
      const channel = xmlChannel.find(chan => chan.webservice === channelName);
      this.setEditScheduleAndRoute(channel, channelName);
    },
    setEditScheduleAndRoute(webservice, channelName) {
      this.setEditSchedule(webservice);
      router.push({ name: 'EditSchedules', params: { webservice: channelName } });
    },
    mapTimes(channel) {
      return channel.schedules.map(e => e.scheduledTimes);
    },
    // eslint-disable-next-line func-names
    updateSearch: debounce(function () {
      this.setScheduleSearch(this.search);
    }, 1000, { leading: true }),
  },
  computed: {
    ...mapState({
      schedules: state => state.schedules.schedules,
    }),
    ...mapGetters({
      xmlChannels: 'schedules/getXmlChannels',
    }),
  },
  created() {
    if (this.schedules.items.length === 0) {
      this.getSchedules();
    }

    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.schedules.pages.schedules'), to: '', disabled: true },
      ],
      title: this.$t('menu.schedules.title'),
    });
  },
};
</script>

<template>
  <v-container class="schedules">
    <v-layout class="row justify-space-between">
      <v-flex xs4>
        <v-text-field
          @input="setScheduleSearch"
          :value="schedules.search"
          label="Search"
          append-icon="search"
          clearable
        >
        </v-text-field>
      </v-flex>
      <v-btn icon @click="getSchedules">
        <v-icon :class="{ 'icon-spin': schedules.loading }">refresh</v-icon>
      </v-btn>
    </v-layout>
    <v-layout class="row wrap schedules__list">
      <tw-overlay :visible="schedules.loading"></tw-overlay>
      <v-progress-circular
        v-if="schedules.loading"
        class="schedules__list-loading"
        indeterminate
      >
      </v-progress-circular>
      <v-flex v-for="xmlChannelName in xmlChannels" :key="xmlChannelName.name" xs12>
        <v-container row wrap>
          <v-card class="grey lighten-4" outlined>
            <v-layout class="row wrap xs12 align-center">
              <v-flex sm3 md2>
                <v-card-title>
                  <h2>{{ xmlChannelName.name }}</h2>
                </v-card-title>
              </v-flex>
              <v-flex offset-sm3 sm4 offset-md7 md2>
                <v-select
                  v-model="channelName"
                  :items="xmlChannelName.items.map(e => e.webservice)"
                  :id="xmlChannelName.name"
                  label="channel"
                >
                </v-select>
              </v-flex>
              <v-flex sm2 md1>
                <v-btn
                  color="info"
                  @click="getRightWebService(xmlChannelName.items, channelName)"
                >
                  Add new
                </v-btn>
              </v-flex>
            </v-layout>
            <v-container
              v-for="xmlChannel in xmlChannelName.items"
              :key="xmlChannel.id"
              row
              wrap
            >
              <v-flex xs12 md12>
                <v-card
                  v-if="xmlChannel.schedules.length !== 0 || xmlChannel.subChannels.length !== 0"
                >
                  <v-card-title class="justify-space-between">
                    <h2>{{ xmlChannel.webservice }}</h2>
                    <v-btn
                      :value="xmlChannel.webservice"
                      color="info"
                      @click="setEditScheduleAndRoute(xmlChannel, xmlChannel.webservice)"
                    >
                      Edit
                    </v-btn>
                  </v-card-title>
                  <v-card-text
                    v-if="xmlChannel.schedules !== null && xmlChannel.schedules.length !== 0"
                  >
                    <p>
                      {{ returnRegularSchedules(mapTimes(xmlChannel)) }}
                    </p>
                    <p
                      v-for="schedule in mapTimes(xmlChannel).sort()"
                      :key="schedule.scheduleId"
                    >
                      {{ returnSpecialSchedules(schedule) }}
                    </p>
                  </v-card-text>
                  <v-container
                    v-if="xmlChannel.subChannels.length !== 0"
                    v-for="subChannel in xmlChannel.subChannels"
                    :key="subChannel.id"
                    class="row wrap py-2"
                  >
                    <v-flex>
                      <v-card>
                        <v-card-title>
                          <b>{{ subChannel.name }}:</b>
                        </v-card-title>
                        <v-card-text
                          v-if="subChannel.schedules !== null  && subChannel.schedules.length !== 0"
                        >
                          <p>
                            {{ returnRegularSchedules(mapTimes(subChannel)) }}
                          </p>
                          <p
                            v-for="schedule in mapTimes(subChannel).sort()"
                            :key="schedule.scheduleId"
                          >
                            {{ returnSpecialSchedules(schedule) }}
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-container>
                </v-card>
              </v-flex>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.schedules {
  position: relative;

  &__list {
    min-height: 150px;

    &-loading {
      position: absolute;
      z-index: 20;
      top: 120px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Schedules.vue